












import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CampoContrasena extends Vue {
  @Prop() value: string;
  @Prop() testId: string;

  isTextoVisible = false;

  handleChange(value: string) {
    this.$emit('input', value);
  }

  handleVisibilityClick() {
    this.isTextoVisible = !this.isTextoVisible;
  }
}
